import { render, staticRenderFns } from "./settings_zones.vue?vue&type=template&id=6de4608f"
import script from "./settings_zones.vue?vue&type=script&lang=js"
export * from "./settings_zones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports